import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { decodeJWTRole } from '../utils/securityMiddleware';
import { getSessionToken, loginPath } from '../utils/session';

/**
 * Route guard for signed-in (and optionally role-restricted) pages.
 *
 * Client-side checks only decide what to show; the backend must still
 * authorize every request ([Authorize] / [Authorize(Roles = "Admin")]).
 */
const ProtectedRoute = ({ allowedRoles = [] }) => {
  const location = useLocation();

  // Signed-out or expired: go to sign-in and come back here afterwards.
  if (!getSessionToken()) {
    return (
      <Navigate to={loginPath(`${location.pathname}${location.search}`)} replace />
    );
  }

  if (allowedRoles.length) {
    const userRole = decodeJWTRole();
    const isAllowed = allowedRoles.some(
      role => userRole && role.toLowerCase() === userRole.toLowerCase()
    );
    if (!isAllowed) {
      return <Navigate to="/" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
